<script lang="ts">
  import { List } from '$shared/components';

  interface Props {
    data: any[];
    title?: string;
  }

  let { data, title = '' }: Props = $props();
</script>

<div class="education-record-list-type-wrapper">
  <div class="education-list-type">
    <div data-cy={`${title}-header`} class="header">
      <div class="title">{title}</div>
    </div>
    <div data-cy={`${title}-contents`} class="contents">
      {#if data}
        {#each data as item, index}
          <div data-cy={`${title}-content_${index}`} class="content-item">
            {#if item['__title']}
              <div class="sub-title">{item['__title']}</div>
            {/if}
            <List list={item.value} />
          </div>
        {/each}
      {:else}
        <div class="warn">No data found</div>
      {/if}
    </div>
  </div>
</div>

<style>
  .education-record-list-type-wrapper {
    width: 100%;
    background-color: #fff;
    padding-bottom: 15px;
  }
  .education-list-type {
    margin-top: 20px;
  }
  .header {
    display: flex;
  }
  .header .title {
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    color: var(--black);
    margin-bottom: 24px;
  }
  .sub-title {
    font-weight: 700;
    font-size: 14px;
    line-height: 26px;
    color: var(--black);
    margin-bottom: 20px;
  }
  .content-item:not(:last-child) {
    margin-bottom: 20px;
  }
</style>
